import { render, staticRenderFns } from "./InformeSitio.vue?vue&type=template&id=6ab9f0c0&scoped=true&"
import script from "./InformeSitio.vue?vue&type=script&lang=ts&"
export * from "./InformeSitio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab9f0c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ab9f0c0', component.options)
    } else {
      api.reload('6ab9f0c0', component.options)
    }
    module.hot.accept("./InformeSitio.vue?vue&type=template&id=6ab9f0c0&scoped=true&", function () {
      api.rerender('6ab9f0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ProgramacionInforme/TiposdeInformes/TipoSitio/InformeSitio.vue"
export default component.exports